<template>
<div class="columns">
    <category-view v-on:delete-category="deleteCategory" v-on:update-category="updateCategory" v-for="category in listCategory" :category="category" :listItem="listItem" v-bind:key="category.key" class="column is-4 box"></category-view>
</div>
</template>

<style scoped>
.box{
    border: 1px solid #ccc;
}
.active{
    border: 1px solid rgb(6, 50, 247);
}
</style>
<script>
import CategoryView from './CategoryView';
import axios from 'axios'
import { ToastProgrammatic as Toast } from 'buefy'

export default {
    data() {
        return {
            input: {
            },
            data : {
                repeatOn : []
            },
            result: "",
        };
    },
    props: ['listCategory',"listItem"],
    components: {
        CategoryView,
    },
    methods: {
        deleteCategory(data) {
            
            this.$swal({
                title: "Confirm?",
                text: "Are you sure you want to remove the category " + data.name + "?",
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showCloseButton: true
            }).then((result) => {
                if (result.value){                    

                    axios.defaults.headers.common["Authorization"] = localStorage.getItem("jwtToken");
                    axios.defaults.responseType = "json";
                    axios.post(process.env.MY_URL + "/super/category/remove", {
                        superEmail: localStorage.getItem("superEmail"),
                        _id: data._id
                    })
                    .then(response => {
                        if (response.data.success == false) {
                            Toast.open({
                                message: response.data.msg,
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        } else {
                            Toast.open({
                                color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                message: response.data.msg,
                                type: 'is-success',
                                duration: 3000
                            })
                        }
                    })
                    .catch(e => {
                        console.log(e.response);
                        if (e.response.status == 400) {
                            Toast.open({
                                message: e.response.data.msg,
                                type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            });
                        } else {
                            Toast.open({
                                message:
                                    "Sorry, an error has occurred. Please try again: " + e.response.statusText,
                                type: "is-danger", //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            });
                        }
                    });
                }
                this.$parent.getCategories()
            })
        },

        updateCategory(data) {
            var name = data.name;
            var points = data.points;
            var items = data.items;
            var colour = data.colour;
            var selectedColour = "";
            
            if (!colour.hex){
                selectedColour = "#0C4BF7"
            }else{
                selectedColour = colour.hex
            }

            if ((!name) || (name.length < 1)){
                Toast.open({
                    message: "Please enter the category name",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }else{
                name = name.trim()
            }
            if (!points){
                Toast.open({
                    message: "Please enter the value for the average marks",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }else{
                points = parseFloat(points)
            }

            axios.defaults.headers.common["Authorization"] = localStorage.getItem("jwtToken");
            axios.defaults.responseType = "json";
            axios.post(process.env.MY_URL + "/super/category/update", {
                    superEmail: localStorage.getItem("superEmail"),
                    _id: data._id,
                    name: name,
                    points: points,
                    items: items,
                    colour: selectedColour
            }).then(response => {
                if (response.data.success == true) {
                    Toast.open({
                        color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        message: response.data.msg,
                        type: 'is-success',
                        duration: 3000
                    })
                } else {
                    Toast.open({
                        message: response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                }
                self.isLoading = false;
            })
            .catch(e => {
                if (e.response.status === 401) {                            
                    Toast.open({
                        message: "Unauthorized access. Please re-login.",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                } else {
                    Toast.open({
                        message: 'Error: ' + e.response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                }
            })
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/components/Super/CategoryList.vue